'use client';

import { useCheckoutContext } from '@instamenu/context-checkout';
import { observer } from 'mobx-react-lite';
import { useMediaQuery } from 'react-responsive';
import { SideMenuBar } from './side-menu-bar';
import { ActionBar } from './action-bar';
import { useUIStateContext } from '../ui-state-context/ui-state-context';
import { breakpoints } from '@instamenu/ui-vanilla-extract';
import { Box, Columns } from '@instamenu/ui-system-next';
import { barStyle } from './cart-menu.css';

export const CartMenu = observer(() => {
  const checkout = useCheckoutContext();
  const order = checkout?.order;

  const isDesktop = useMediaQuery({ query: breakpoints.desktop });
  const { isCartOpen } = useUIStateContext();

  if (!checkout || !order) return null;

  const shouldShowSideMenuBar = (isDesktop && order.orderItems.length > 0) || isCartOpen;

  return shouldShowSideMenuBar ? (
    <SideMenuBar order={order} isDesktop={isDesktop} />
  ) : (
    <Box className={barStyle}>
      <Columns style={{ padding: '12px' }}>
        <ActionBar buttonProps={{ size: 'full' }} />
      </Columns>
    </Box>
  );
});
